import { useState } from 'react';

import { cn } from '@/utils/helper';

interface NumberTooltipProps {
  children: React.ReactNode;
  fullNumber?: number | string;
  symbol?: string;
  wrapperClassName?: string;
  tooltipClassName?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

const NumberWithTooltip: React.FC<NumberTooltipProps> = ({ children, fullNumber, symbol, wrapperClassName, tooltipClassName, position = 'top' }) => {
  const [isFocused, setIsFocused] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 -mt-1 rotate-45',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 -mb-1 rotate-45',
    left: 'left-full top-1/2 -translate-y-1/2 -ml-1 rotate-45',
    right: 'right-full top-1/2 -translate-y-1/2 -mr-1 rotate-45',
  };

  const showTooltip = isFocused || undefined;

  if (!fullNumber || fullNumber === 'N/A') return <>{children}</>;

  return (
    <div className={cn('relative z-10 cursor-pointer', wrapperClassName)} onMouseEnter={() => setIsFocused(true)} onMouseLeave={() => setIsFocused(false)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}>
      <div role='tooltip' aria-hidden={!showTooltip} className={cn('absolute z-10 bg-primary  text-[10px]/3 font-space-mono font-normal !text-white py-1 px-2 w-max', positionClasses[position], showTooltip ? 'flex' : 'hidden', tooltipClassName)}>
        <span
          style={{
            color: 'inherit',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            fontStyle: 'inherit',
          }}
          className='block relative z-10'
        >
          {fullNumber} {symbol}
        </span>
        <div className={cn('absolute h-2 w-2 bg-primary', arrowClasses[position])} aria-hidden='true' />
      </div>
      {children}
    </div>
  );
};

export default NumberWithTooltip;
